module.exports = __webpack_public_path__ + "img/thunderstorm with light rain.cd62a1af.jpg";